import { LOCAL } from "@/store/mutations";

const { SET_BALANCE } = LOCAL;

export default {
	namespaced: true,
	state: {
		amount: 0,
	},
	actions: {
		configureApp: {
			root: true,
			handler({ commit }, configData) {
				commit(SET_BALANCE, { amount: configData.config.starting_balance });
			},
		},
		deposit({ state, commit }, deposit) {
			const amount = state.amount + deposit.amount;
			commit(SET_BALANCE, { amount });
		},
		withdraw({ commit, state }, withdrawal) {
			const amount = Math.max(state.amount - withdrawal.amount, 0);
			commit(SET_BALANCE, { amount });
		},
	},
	mutations: {
		[SET_BALANCE](state, balance) {
			state.amount = balance.amount;
		},
	},
};
